import React,{useEffect,useRef} from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const RedBanner = ()=>{
    const sec1 = useRef(null);

    useEffect(() => {
        gsap.set(sec1.current, { opacity: 0, y: 100 });
        gsap.to(sec1.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec1.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);

    return(
        <section className="w-full font-guton">
            <div ref={sec1} className="w-90 mx-auto bg-custom-gradient flex flex-col justify-center items-center rounded-xl pt-6 md:pt-6 md:pb-4 xl:py-12 max-w-[1440px]">
            <h2 className="text-white text-center w-90 leading-22 md:w-auto text-26 md:text-36 xl:leading-60 xl:text-64 mb-1 md:mb-3 tracking-[-1px] xl:tracking-[-3px] font-medium"><span className="block sm:inline">Ready to</span> <span className="block sm:inline">Start your Journey?</span></h2>
                <p className="hidden md:block w-70 md:w-55 text-center text-white text-9 leading-9 md:text-18 xl:text-32 md:leading-18 xl:leading-32 tracking-[-0.4px] xl:tracking-[-0.7px]">Take the first step toward studying abroad with confidence. We’re here to help you succeed.</p>
                <div className="flex w-fit text-11  md:text-14 xl:text-25 mt-2 mb-6 md:my-6">
                    <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton font-semibold bg-whiteExtra text-black px-2 md:px-4 xl:px-6 rounded-full py-1 md:py-2 xl:py-3 md:leading-16 xl:leading-30 hover:text-white hover:bg-custom-hover-gradient transition duration-500 ease-in-out">Start Your Journey</a>
                </div>
            </div>
        </section>
    )
}

export default RedBanner;